import React, { useEffect, useState } from 'react'
import { Panel, TextFieldIcon, SelectFieldIcon } from '../../../_components'

export default function Plot( { tag, values, handleChange, handleBlur, data } ) {
  const [ codes, setCodes ] = useState( [] )

  useEffect( () => {
    if( localStorage.getItem( "tag" ) === "edit" || localStorage.getItem( "tag" ) === "view" ) {
        fetchCodes( values.block_number )
    }
  },[ localStorage.getItem( "tag" ) ])

  const fetchCodes = ( val ) => {
    if( val && val !== "" ) {
        setCodes( data.codes.filter( code => {
            return code.block === val
        } ) )
    }
  }

  return (
    <Panel label="Location">
        <div className="grid md:grid-cols-2 md:gap-2 lg:grid-cols-3 lg:gap-3">
            <SelectFieldIcon 
                name="block_number"
                handleChange={( evt ) => {
                    handleChange( evt )
                    fetchCodes( evt.target.value )
                } } 
                handleBlur={handleBlur}
                value={values.block_number}
                label="Block No"
                required={true}
                question="Block Number"
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                options={data.blocks.map( block => ( { id: block.id, label: block.label, value: block.value } ) )} />

            {localStorage.getItem( "tag" ) === "view" ? <TextFieldIcon 
                name="ffs_code"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.ffs_code}
                label="FFSG Number"
                required={false}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                question="FFSG Number" /> 
                : 
                ( <SelectFieldIcon 
                name="ffs_code"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.ffs_code}
                label="FFSG No."
                required={true}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                question="FFSG Number / Name"
                options={codes.map( item => ( { id: item.code, label: item.code, value: item.code } ) )} 
            /> ) } 

            <div />

            <TextFieldIcon 
                name="plotno"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.plotno}
                label="Plot No"
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                required={true}
                question="Plot Number" />

            <TextFieldIcon 
                name="plot_size"
                type="number"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.plot_size}
                label="Plot size"
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                required={true}
                question="Size of the plot occupied( in acres)" />

            {localStorage.getItem( "tag" ) === "view"  ? 
            !localStorage.getItem( "scheme" ) === "Tochi" &&
            ( <TextFieldIcon 
                    name="land_ownership"
                    handleChange={handleChange} 
                    handleBlur={handleBlur}
                    value={values.land_ownership}
                    label="Land Ownership Status"
                    required={false}
                    disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                    question="Land Ownership Status" />  )
                : 
                !localStorage.getItem( "scheme" ) === "Tochi" && 
                ( <SelectFieldIcon 
                    name="land_ownership"
                    handleChange={handleChange} 
                    handleBlur={handleBlur}
                    value={values.land_ownership}
                    label="Land Ownership"
                    required={false}
                    disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                    question="Land Ownership"
                    options={data.landownership.map( land => ( { id: land.id, label: land.label, value: land.value } ) )} 
                /> ) }
        </div>
    </Panel>
  )
}
